import cx from 'classnames';
import React from 'react';
import styles from './content-grid.module.scss';
/** Total number of content columns in the grid. */
export const CONTENT_GRID_COLUMNS = 12;
// +1 in the placement formula accounts for 1-based CSS Grid track indexing.
const CONTENT_GRID_MARGIN_TRACKS = 1;
/**
 * Centers page content in a 12-column grid with auto-growing side margins.
 * Columns grow up to 72px; beyond that the side margins expand instead.
 *
 * @example
 * <ContentGrid as="section" span={8} aria-label="Feature management">
 *   <FeatureList />
 * </ContentGrid>
 */
export const ContentGrid = React.forwardRef(({ as: Component = 'div', span = 8, grow = false, className, style, children, ...rest }, ref) => {
    const offset = (CONTENT_GRID_COLUMNS - span) / 2;
    const startTrack = offset + CONTENT_GRID_MARGIN_TRACKS + 1;
    const gridColumn = `${startTrack} / ${startTrack + span}`;
    return (React.createElement("div", { className: cx(styles.grid, grow && styles.gridGrow) },
        React.createElement(Component, { ref: ref, style: { ...style, gridColumn }, className: cx(styles.item, grow && styles.itemGrow, className), ...rest }, children)));
});
ContentGrid.displayName = 'ContentGrid';
//# sourceMappingURL=content-grid.js.map